// The AWAY glyph in the zoomed view's canvas: a "no entry" ring with a "/" slash, the SAME drawing as the grid's away badge (clusterService, the
// pulse-away-badge group), so the zoomed view and the grid say the same thing. It used to be a bare "\\" bar here and a ring + "/" there (Chris, 2026-10-12:
// "Is there a way we can use the circle with line through it as the zoomed in glyph for away also?").
//
// ONE shape for BOTH of the cloud engine's draw paths (the batched crowd and the per-dot one). It adds a single path that the caller fills white on a dark
// halo: a ring (outer circle clockwise, inner circle counter-clockwise, which is the hole) plus a clockwise bar, so a non-zero fill leaves the hole open and the
// bar solid across it. Proportions are the badge's own: ring radius 0.5g, ring stroke 0.42 of that, slash half-extent 0.62 of that, where g is the glyph unit.
//
// Kept in its own module, with no imports, so it can be tested against a recording canvas without loading the cloud engine.

export const AWAY_GLYPH = {
  OUTER: 0.605, // ring outer radius, in glyph units
  INNER: 0.395, // ring inner radius
  HALF_LENGTH: 0.44, // half the slash's length: it ends inside the ring's body
  HALF_THICK: 0.105, // half the slash's thickness (the ring's own thickness / 2)
};

const TAU = Math.PI * 2;

export const awayGlyphPath = (ctx: CanvasRenderingContext2D, x: number, y: number, g: number): void => {
  const outer = g * AWAY_GLYPH.OUTER;
  const inner = g * AWAY_GLYPH.INNER;
  ctx.moveTo(x + outer, y);
  ctx.arc(x, y, outer, 0, TAU, false);
  ctx.moveTo(x + inner, y);
  ctx.arc(x, y, inner, 0, TAU, true);

  // the slash runs bottom-left to top-right, like the badge's; a corner is `along` the slash and `across` it, rotated 45 degrees
  const c = Math.SQRT1_2;
  const half = g * AWAY_GLYPH.HALF_LENGTH;
  const thick = g * AWAY_GLYPH.HALF_THICK;
  const at = (along: number, across: number): [number, number] => [x + c * along + c * across, y - c * along + c * across];
  const a = at(-half, -thick);
  const b = at(half, -thick);
  const d = at(half, thick);
  const e = at(-half, thick);
  ctx.moveTo(a[0], a[1]);
  ctx.lineTo(b[0], b[1]);
  ctx.lineTo(d[0], d[1]);
  ctx.lineTo(e[0], e[1]);
  ctx.closePath();
};
